module.exports = __webpack_public_path__ + "static/img/sunandhini.20bd8a81.jpg";